import { Table } from "antd"
import React, { useEffect, useState } from "react"
import moment from "moment"
import PriceRequestStatus from "../../../components/Admin/PriceRequest/PriceRequestStatus"
import RequestHistory from "../../../components/Admin/PriceRequest/RequestHistory"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../../../firebase/config"

export default function ClosedRequests({ activeKey }) {
  const [closedRequests, setClosedRequests] = useState([])
  const [requestsLoading, setRequestsLoading] = useState(false)

  useEffect(() => {
    if (activeKey === 2) {
      setRequestsLoading(true)
      const reqRef = collection(db, "priceCalculation")

      const reqQuery = query(reqRef, where("adminRequested", "==", false))

      const unsubscribe = onSnapshot(reqQuery, (snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        setClosedRequests(data)
        setRequestsLoading(false)
      })

      return () => unsubscribe()
    }
  }, [activeKey])

  const columns = [
    {
      title: "Status",
      dataIndex: "adminRequestStatus",
      width: "5%",
      render: (value, record) => {
        return (
          <>
            <PriceRequestStatus value={value} />
          </>
        )
      },
    },
    {
      title: "Client",
      dataIndex: "id",
      width: "25%",
    },
    {
      title: "Product",
      dataIndex: ["product", "productName"],
      width: "25%",
    },
    {
      title: "For manager",
      width: "15%",
      dataIndex: "userEmail",
    },

    {
      title: "History",
      align: "center",
      render: (record) => {
        return <RequestHistory record={record} />
      },
    },
    {
      title: "Request Date",
      width: "15%",
      render: (text, record) => {
        // Assuming record.adminRequests contains your Firebase timestamp objects
        const lastAdminRequest =
          record.adminRequests && record.adminRequests.length > 0
            ? record.adminRequests[record.adminRequests.length - 1]
            : null

        // Convert Firebase timestamp to Moment.js date object and format it
        if (lastAdminRequest) {
          // Ensure 'requestDate' exists and has 'seconds'
          if (lastAdminRequest.requestDate && "seconds" in lastAdminRequest.requestDate) {
            // Convert seconds to milliseconds for Moment.js and format the date
            const formattedDate = moment(lastAdminRequest.requestDate.seconds * 1000).format(
              "DD.MM.YYYY"
            )
            return formattedDate
          }
        }

        return "No Date" // Fallback if no date is available
      },
      align: "center",
    },
  ]
  return (
    <div>
      <Table
        columns={columns}
        size="small"
        loading={requestsLoading}
        rowKey={(record) => record.id}
        dataSource={closedRequests}
      />
    </div>
  )
}
